import React from 'react';
import ReactDOM from 'react-dom';
import "rxjs";
import {Provider} from "react-redux";
import {applyMiddleware, compose, createStore} from "redux";
import {createEpicMiddleware} from "redux-observable";
import {rootEpic} from "./epics/root";
import registerServiceWorker from './registerServiceWorker';
import {routerEnhancer, routerMiddleware} from "./reducers/router";
import {rootReducer} from "./reducers/root";
import App from "./components/App";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewares = [
    createEpicMiddleware(rootEpic),
    routerMiddleware
];
const store = createStore(rootReducer, {}, composeEnhancers(routerEnhancer, applyMiddleware(...middlewares)));
ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root')
);


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js